import React, { Component } from 'react';
import { Pagination } from '@cimpress/react-components';

export default class PaginationDemo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      marginValue: 1,
      middleValue: 3,
      pageCount: 50,
    };
  }

  onPageChange = ({ selected }) => {
    this.setState({ page: selected + 1 });
  };

  onMarginValueChange = event => {
    this.setState({ marginValue: Number(event.target.value) });
  };

  onMiddleValueChange = event => {
    this.setState({ middleValue: Number(event.target.value) });
  };

  onPageCountChange = event => {
    this.setState({ pageCount: Number(event.target.value) });
  };

  render() {
    return (
      <div>
        <h5> Play with input props </h5>

        <div style={{ marginLeft: '10px' }}>
          pageCount:
          <input
            style={{ width: '50px', margin: '5px', padding: '2px' }}
            type="number"
            name="marginValue"
            value={this.state.pageCount}
            onChange={this.onPageCountChange}
          />
          <br />
          pagesOutsideElipses:
          <input
            style={{ width: '50px', margin: '5px', padding: '2px' }}
            type="number"
            name="marginValue"
            value={this.state.marginValue}
            onChange={this.onMarginValueChange}
          />
          <br />
          pagesBetweenElipses:
          <input
            style={{ width: '50px', margin: '5px', padding: '2px' }}
            type="number"
            name="middleValue"
            value={this.state.middleValue}
            onChange={this.onMiddleValueChange}
          />
        </div>

        <h4>
          {' '}
          <strong>Current Page</strong>: {this.state.page}{' '}
        </h4>
        <Pagination
          initialPage={0}
          pageCount={this.state.pageCount}
          onPageChange={this.onPageChange}
          pagesOutsideElipses={this.state.marginValue}
          pagesBetweenElipses={this.state.middleValue}
        />
      </div>
    );
  }
}
